const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Radio", "uipress-lite"),
  moduleName: "uip-radio-input",
  description: __("Outputs a radio type input", "uipress-lite"),
  group: "form",
  icon: "radio_button_checked",
};
